import { useCallback, useEffect, useRef, useState } from "react";

export const usePairWatchListSnapshot = () => {
  const [snapshotPending, setSnapshotPending] = useState(false);
  const [retryKey, setRetryKey] = useState(0);
  const retryTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => () => {
    if (retryTimer.current) clearTimeout(retryTimer.current);
  }, []);

  const handleSnapshotError = useCallback((error: any) => {
    if (error.response?.status !== 503) return false;
    setSnapshotPending(true);
    if (retryTimer.current) clearTimeout(retryTimer.current);
    retryTimer.current = setTimeout(() => setRetryKey((key) => key + 1), 5000);
    return true;
  }, []);

  const handleSnapshotResponse = useCallback(() => {
    setSnapshotPending(false);
    if (retryTimer.current) clearTimeout(retryTimer.current);
    retryTimer.current = null;
  }, []);

  return { snapshotPending, retryKey, handleSnapshotError, handleSnapshotResponse };
};
